<template>
  <main class="timeline">

    <div id="evtContainer">
      <section v-for="(event, i) in events" :key="i" :class="classGenerator(i)">
        <div>
          <img :src="event.icon" class="ach_icon" />
          <h2>{{ event.title }}</h2>
          <p>
            {{ event.desc }}
          </p>

          <p class="ev_date">
            {{ dateFormat(event.date) }}
          </p>
        </div>
      </section>

      <div class="spinerParent" v-if="loading">
        <img src="../assets/spinb.png" />
      </div>
    </div>

  </main>
</template>

<script>
import Request from "../mixins/axiosRequest";
import * as timeago from "timeago.js";

export default {
  name: "Timeline",
  data() {
    return {
      events: {},
      loading: true
    };
  },

  methods: {
    async getEvents() {
      let data = await Request.axiosGet("/api/timeline", this.client);
      if(data.status) {
        this.events = data.data;
        this.events = this.events.reverse();
      } else {
        this.fetchErr = data.data;
      }
      this.loading = false;
    },

    dateFormat(raw) {
      return timeago.format(raw);
    },

    classGenerator(index) {
      let max = this.events.length - 1;
      if (index == 0) {
        return "event last";
      } else if (max == index) {
        if (index % 2 == 0) {
          return "event first_";
        } else {
          return "event_ first";
        }
      } else if (index % 2 == 0) {
        return "event";
      } else if (index % 2 == 1) {
        return "event_";
      }
    }
  },

  mounted() {
    this.getEvents();
    this.loading = true;
  }
};
</script>

<style scoped lang="scss">
@media (prefers-color-scheme: dark) {
  .event div, .event_ div {
    background-color: #00000044;
  }
}

@media (prefers-color-scheme: light) {
  .event div, .event_ div {
    background-color: #ffffff44;
  }
}

.timeline {
  display: flex;
  height: auto;
  margin: 0px auto 0 auto;
  max-width: 1366px;
  overflow: auto;
  transform: rotateX(180deg);
  width: 100%;
}

#evtContainer {
  min-height: 45vh;
  display: flex;
  /* flex-direction: column; */
  align-items: center;
  z-index: 10;

  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
  z-index: 5;
  margin: 0 5px;
  transform: rotateX(180deg);
}

.eventCont {
  z-index: 100;
}

.event, .event_ {
  padding: none;
  background-image: url("../assets/timeline/timelinebg_.png");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 65vw;
  height: 65vw;
  max-width: 650px;
  max-height: 650px;
  margin: 0 auto;
  background-color: transparent;
  z-index: 10;
}

.event {
  background-image: url("../assets/timeline/timelinebg_.png");
}

.event_ {
  background-image: url("../assets/timeline/timelinebg.png");
}

.event div, .event_ div {
  position: relative;
  height: 82.5%;
  width: 82.5%;
  border-radius: 50%;

  margin: 110px 0;

  top: 0px;
  left: 2px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 527px;
  max-height: 527px;

}

.last {
  background-image: url("../assets/timeline/timelinebg_last.png");
  div {
    top: 0px;
    left: -2px;
  }
}

.first {
  background-image: url("../assets/timeline/timelinebg_first.png");
  div {
    top: 0px;
    left: -2px;
  }
}

.first_ {
  background-image: url("../assets/timeline/timelinebg_first_.png");
  div {
    top: 0px;
    left: -2px;
  }
}

h2 {
  font-size: 2em;
  letter-spacing: 1px;
  color: #000;
}

.event p, .event_ p {
  margin-top: 10px;
  font-size: 1em;
}

.ach_icon {
  height: 180px;
  width: 180px;
  border-radius: 50%;
  margin-top: 20px;
  margin-bottom: 15px;
  object-fit: cover;
}

.ev_date {
  font-style: italic;
}

@media screen and (max-width: 975px) {

  h2 {
    font-size: 1.6em;
    letter-spacing: 2px;
  }

  .event, .event_ {
    width: 80vw;
    height: 80vw;
  }


  .event div, event_ div {
    height: 82.5%;
    width: 82.5%;
    border-radius: 50%;
  }
}

@media screen and (max-width: 795px) {

  h2 {
    font-size: 1.45em;
  }

  .event, .event_ {
    width: 88vw;
    height: 88vw;
  }

  .event div, .event_ div {
    height: 83%;
    width: 83%;
  }


  .event p, .event_ p {
    margin-top: 5px;
    font-size: 0.85em;
  }

  .ach_icon {
    height: 130px;
    width: 130px;
    margin-top: 0px;
    margin-bottom: 5px;
  }

}

@media screen and (max-width: 495px) {

  .event p, .event_ p {
    margin-top: 5px;
    font-size: 0.8em;
  }

  .ach_icon {
    height: 130px;
    width: 130px;
  }


  h2 {
    font-size: 1.41em;
    letter-spacing: 1.8px;
  }
  .event, .event_ {
    width: 100vw;
    height: 100vw;
  }

}

@media screen and (max-width: 380px) {

  .event p, .event_ p {
    margin-top: 3px;
    font-size: 0.65em;
  }

  h2 {
    font-size: 1.14em;
    letter-spacing: 1.8px;
  }
}
</style>
